const BASE_URL_OPR_FULL = process.env.REACT_APP_OPR_FULL_URL_BASE;
const BASE_URL_PWA_FULL = process.env.REACT_APP_PWA_FULL_URL_BASE;
const publishedStatusPanelFull = ['ONLINE', 'OFFLINE'];

/**
 * Retorna la url que redirecciona al portal de full, para ver el estado del draft o administrar el posting.
 * En caso de ser un draft redirecciona al OPR y si esta online o rentado al PWA.
 * @param {string} status
 * @param {string} params
 * @param {integer} postingId
 * @param {integer} postingIdHome
 * @param {string} UUIDdraft
 * @returns {string}
 */

export const getRedirectUrlFull = (status, params, postingId, postingIdHome, UUIDdraft) => {
  const getParams = !['', null].includes(params) ? params : '';
  // Redirect hacia el OPR cuando el aviso tiene el status de 'DRAFT' o es Target para convertir en Full
  if (status === 'DRAFT') {
    return `${BASE_URL_OPR_FULL}/novo-imovel?draft_id=${UUIDdraft}${getParams ? `&${getParams}` : ''}`;
  }
  // Redirect hacia el PWA cuando el aviso está convertido a FULL (status 'ONLINE' y 'OFFLINE')
  if (publishedStatusPanelFull.includes(status)) {
    return `${BASE_URL_PWA_FULL}/meus-imoveis/${postingIdHome}${getParams ? `?${getParams}` : ''}`;
  }
  // Redirect hacia el ONBOARDING cuando el aviso es isTargetI24Full=true
  return `${window.location.origin}/panel/servicios/full?utm=avisosCard&postingId=${postingId}`;
};
